export default "__VITE_ASSET__B4rGsQFM__"